module.exports = __webpack_public_path__ + "img/books_walkthrough_1.044238f0.png";